import React from "react";
import Box from "@mui/material/Box";
import {
  getAgentStatusDot,
  getCustomerStatusStyle,
  getCustomerStatusLabel,
} from "../../../utils/peopleHelpers";

export default function StatusChip({ status, withDot = false }) {
  if (withDot) {
    return (
      <Box
        sx={{
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "6px",
          height: 24,
          minWidth: 72,
          px: "8px",
          borderRadius: "20px",
          border: "1px solid #C5CED6",
          background: "#FFF",
          boxShadow: "0px 1px 2px 0px rgba(6, 21, 34, 0.05)",
          boxSizing: "border-box",
          flexShrink: 0,
        }}
      >
        <Box
          component="span"
          sx={{
            width: 8,
            height: 8,
            borderRadius: "50%",
            bgcolor: getAgentStatusDot(status),
            flexShrink: 0,
          }}
        />
        <Box
          component="span"
          sx={{
            color: "#405261",
            fontFamily: "Inter",
            fontSize: 12,
            fontWeight: 500,
            lineHeight: 1,
            whiteSpace: "nowrap",
          }}
        >
          {getCustomerStatusLabel(status)}
        </Box>
      </Box>
    );
  }

  return <Box sx={getCustomerStatusStyle(status)}>{getCustomerStatusLabel(status)}</Box>;
}
